var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage"
  }, [_c('div', {
    staticClass: "activity-container"
  }, [_c('section', {
    staticClass: "question-section"
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound && _vm.currentRound.questionHtml
    }
  })], 1), _c('text-editor', {
    ref: "textEditor",
    staticClass: "text-editor",
    attrs: {
      "maxLength": _vm.maxLength,
      "autoFocus": true,
      "editable": !_vm.isMobile,
      "keyboardAdaptationWrapperMinElementHeight": _vm.isMobile ? 50 : 100,
      "isMobile": _vm.isMobile
    },
    model: {
      value: _vm.answer,
      callback: function ($$v) {
        _vm.answer = $$v;
      },
      expression: "answer"
    }
  }), _vm._t("keyboard")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }